import { deepMerge } from '@empathybroker/deep-merge';
import { ConfigState, DynamicConfig } from '../../../models';
import { DeepPartial } from '../../../utils';
import { CONFIG_MUTATIONS_KEYS } from '../config.const';
import { ConfigMutation } from '../config.interfaces';

export class SetDynamicConfigMutation implements ConfigMutation {
  mutations = {
    [CONFIG_MUTATIONS_KEYS.setDynamicConfig]: (configState: ConfigState, newConfig: DeepPartial<DynamicConfig>) => {
      deepMerge(configState.dynamic, newConfig);
    }
  };
}
